export const es = {
  header: {
    support: 'Hablar con soporte',
    contact: 'Contactenos',
    dialogs: {
      notification: {
        heading: 'Notificaciones',
        action: 'Marca todas como leidas',
        empty: 'Nada pendiente :)',
        message: {
          heading: 'Entrenamiento Chroma',
          text: 'Ahora esta disponible el entrenamiento en vivo de Chroma',
          link: 'Agendar tu entrenamiento',
        },
      },
      user: {
        settings: 'Configuracion',
        logout: 'Cerrar sesion',
      },
    },
  },
  footer: {
    terms: 'Termino de Servicios',
    policy: 'Politica de Privacidad',
  },
  nav: {
    dashboard: 'Dashboard',
    products: 'Mis Productos',
    preTraining: 'Pre-Entrenamiento',
    postTraining: 'Post-Entrenamiento',
    schedule: 'Agendar Clases',
    orders: 'Mis Ordenes',
    transactions: 'Transacciones',
    referrals: 'Recompensas',
  },
  dashboard: {
    events: {
      heading: 'Events',
      table: {
        h1: 'ticket',
        h2: 'codigo',
        h3: 'estado',
      },
    },
    products: {
      heading: 'Mis Productos',
      action: 'ver todos',
      link: 'Iniciar Pre-Entrenamiento',
    },
    orders: {
      heading: 'Mis Ordenes',
      action: 'ver todos',
    },
    referrals: {
      heading: 'Recompensas',
      action: 'ver todos',
      message: 'Personas Que He Referido',
    },
    facebook: {
      title: 'Hazte miembro del grupo Oficial de Usuarios de Ricoma en Facebook',
      content:
        'Ahora puedes unirte a un grupo privado de élite de decoradores de ropa personalizados en Facebook. Esta comunidad exclusiva está llena de profesionales y aficionados que son maestros en su oficio. Al unirte, obtendrás acceso a esta red de apoyo donde podrás hacer preguntas, compartir proyectos, intercambiar consejos de decoración y mucho más.',
      link: 'Unete ahora',
    },
    decosummit: {
      title: 'AHORRE 20% DE DESCUENTO CON CÓDIGO',
      content:
        'Utilice su código de descuento anterior para ahorrar un 20 % de descuento en entradas para DecoSummit 2024.',
      link: 'Consigue tu entrada ahora',
    },
    giftcards: {
      title: 'SALDO DE LA TARJETA DE REGALO',
      view: 'Ver detalles',
      text:
        'Para canjear su tarjeta de regalo, simplemente ingrese el código al momento del pago en',
    },
    ad: {
      link: 'Comprar ahora',
    },
    salesRep: {
      heading: 'Mi Representante',
    },
  },
  products: {
    heading: 'Mis Productos',
  },
  product: {
    link: 'Iniciar Pre-Entrenamiento',
    chroma_link: 'Descargar Ahora',
  },
  productDetails: {
    header: {
      heading: 'Mis Productos',
    },
    pendingSubscriptionsLegacy: {
      heading: 'Licencias disponibles para actualizacion de suscripcion',
    },
    pendingSubscriptions: {
      heading: 'Licencias pendientes de activacion',
    },
    resources: {
      heading: 'Recursos',
      download: 'Descargar',
      watch: 'Mira los Videos de Entrenamiento',
    },
    videos: {
      heading: 'Videos de Entrenamientos',
      heading_chroma: 'Videos de Entrenamientos',
      action1: 'ver todos',
      action2: 'compactar vista',
    },
    normal_videos: {
      heading: 'Videos',
      action1: 'ver todos',
      action2: 'compactar vista',
    },
    accessories: {
      heading: 'Maximizar tu Inversion',
      link: 'Comprar ahora',
    },
    card: {
      machines: {
        serial: 'Numero Serial',
        date: 'Ordenado',
        text: 'Pre-Entrenamiento esta ahora disponible para tu {machine}.',
        link: 'Iniciar Pre-Entrenamiento',
      },
      chroma: {
        serial: 'Numero Serial',
        tier: 'Linea',
        date: 'Ordenado',
        action: 'Acciones',
        text: 'Actualice de {chroma1} a {chroma2}',
        link: 'ADMINISTRAR SUSCRIPCIONES',
        note: '¿Quiere realizar cambios en su cuenta?',
        upgrade: 'MEJORA',
        active: 'ACTIVA',
        manage: 'ADMINISTRAR',
      },
      chroma_legacy: {
        serial: 'Número de serie',
        tier: 'Nivel',
        date: 'Ordenado',
        action: 'Acciones',
        text: 'Actualice de {chroma1} a {chroma2}',
        link: 'QUÉ HAY DE NUEVO',
        note:
          '<p class="mb-1 text-left" style="color: #F17D21;font-size: 12px">ACTUALIZACIÓN DISPONIBLE</p><p class="mb-1 text-left" style="font-weight: 700;font-size: 16px; ">Ahorre hasta $2000 actualizando su licencia heredada de Chroma a una suscripción</p><p class="mb-2 text-left">Disfrute de actualizaciones ilimitadas de funciones, más de 97 fuentes nuevas, fondos de textura, vistas realistas mejoradas y más según el plan seleccionado. Conozca todas las funciones nuevas que ofrece una suscripción a Chroma.</p>',
        upgrade: 'MEJORA',
        active: 'ACTIVA',
        manage: 'ADMINISTRAR',
      },
      chroma_promo: {
        note: 'Prueba gratuita disponible',
        title: '¡Experimenta todas las funciones de Chroma Luxe gratis durante 14 días!',
        content:
          '¿Estás listo para llevar tus habilidades de digitalización al siguiente nivel? Comienza tu prueba gratuita de 14 días con Chroma y explora las herramientas avanzadas de digitalización de Luxe, incluyendo más de 250 fuentes pre-digitalizadas, modelos 3D y mucho más<b >—sin compromiso, sin necesidad de tarjeta de crédito.</b>',
        button: 'PRUÉBALO GRATIS POR 14 DÍAS →',
      },
    },
  },
  preTraining: {
    heading: 'Pre-Entrenamiento',
    subheading: 'Seleccione su maquina',
    continueBtn: 'Continuar Pre-Entrenamiento',
    startBtn: 'Iniciar Pre-Entrenamiento',
    takeQuizBtn: 'Realizar Quiz',
    takeNoQuizBtn: 'Siguiente',
    submitQuiz: 'Enviar Quiz',
    scheduleBtn: 'Agendar Entrenamiento',
    noPretrainingAvailable: 'No hay Pre-Entrenamiento disponible para tu idioma',
    video: {
      heading: 'El video ha finalizado',
      subheading: '',
      subheadingStart: 'Seleccione "Iniciar Pre-Entrenamiento" para continuar.',
      subheadingContinue: 'Seleccione "Continuar Pre-Entrenamiento" para proceder.',
      subheadingSchedule: 'Seleccione "Agendar Entrenamiento" para continuar.',
      subheadingQuiz: 'Seleccione "Realizar Quiz" para continuar.',
      replayBtn: 'Repetir video',
    },
    intro: {
      listHeading: 'Lo que cubriras en este pre-entrenamiento',
      listPrefix: 'Clase {number}: ',
    },
    lesson: {
      heading: 'Clase {number}: ',
      resources: 'Recursos',
    },
    checklist: {
      title: 'Lista de Chequeo del Pre Entrenamiento',
    },
    warning: {
      title: 'POR FAVOR LEE Y ACEPTA',
      content:
        'Los clientes son responsables de completar esta sesión the pre-entrenamiento antes de las 10 horas de capacitación técnica presencial. Si no se completa, el tiempo que el técnico dedique a enseñarle el pre-entrenamiento se reducirá a las 10 horas requeridas de capacitación. Los clientes no podrán recuperar este tiempo durante o después de la capacitación presencial. <b>Si no se completa el pre-entrenamiento y las 10 horas de capacitación presencial, su garantía será anulada.</b>',
      checkbox: 'Reconozco esto y estoy listo para comenzar el pre-entrenamiento.',
      button: 'Comenzar pre-entrenamiento',
    },
    vision: {
      warning: {
        title: 'POR FAVOR LEE Y ACEPTA',
        content:
          'No encienda ni opere la máquina antes de la capacitación en línea. De lo contrario, se producirán posibles daños a la máquina y la anulación de la garantía.<br><br>Si tiene alguna pregunta, póngase en contacto con nosotros en: <a href="mailto:service@ricoma.com">service@ricoma.com</a>',
        checkbox: 'Reconozco esto y estoy listo para comenzar el pre-entrenamiento.',
        button: 'Comenzar pre-entrenamiento',
      },
    },
    thank_you: {
      content:
        "Thank you! We're thrilled to begin scheduling your training. You should have an email from us outlining the next steps to book your online training session.",
      button: 'close',
      content_warning: {
        'p-1':
          'Te enviamos un correo electrónico sobre la activación de tu formación. Para garantizar un comienzo sin problemas, siga los pasos descritos en el correo electrónico.',
        'p-2':
          "¿No has visto nuestro correo electrónico? ¡No hay problema! Simplemente <a href='https://ricoma.com/US/support' target='_blank' class='text-blue-500'>haga clic aquí</a> para crear un ticket de soporte y estaremos en contacto para asegurarse de que esté todo listo.",
      },
    },
  },
  postTraining: {
    heading: 'Post-Training',
    subheading: 'Seleccione su maquina para acceder a sus recursos de Post entrenamiento.',
    link: 'Mira Post-Training Videos',
    dtg: {
      heat_press: 'Heat Press Ajustes',
      pre_treated: 'Pre-Tratado Camisas',
      warranty: {
        heading: 'Ri 1000/2000 Recursos posteriores a la capacitación',
        subheading: 'Especificaciones de Garantia que debes saber',
        card: {
          heading: 'Antes de poder acceder a sus recursos Ri 1000/2000...',
          text:
            'Lea la información de garantía a continuación y confirme que ha leído y comprendido',
        },
        button: 'He leído y entendido',
        pdf: 'Descargar PDF',
        list: {
          't-1':
            '<b>NUNCA MUEVA LA IMPRESORA SIN SEGUIR EL PROCEDIMIENTO APROPIADO DE ALMACENAMIENTO O ENVÍO, DESPUÉS DE QUE SE HAYAN INSTALADO LOS CARTUCHOS DE TINTA. SI NO ESTÁ SEGURO DE CÓMO HACER ESTO, PÓNGASE EN CONTACTO CON AYUDA AL CLIENTE.</b>',
          't-2':
            '<b>NO APAGUE SU impresora por NINGÚN motivo, a menos que esté llena con el líquido de limpieza y tapada, a menos que el video de mantenimiento lo indique.</b>',
          't-3':
            '<b>Siempre deje la impresora encendida para permitir que se ejecuten las secuencias de mantenimiento automatizadas de la máquina.</b> Esto es necesario para mantener la impresora en óptimas condiciones y evitar posibles daños que se pueden prevenir fácilmente. <b>Si es necesario apagar la máquina durante más de 12 horas, asegúrese de llenar la impresora con líquido de limpieza.</b> Consulte la Sección 8.3 de su Manual de usuario para obtener más información.',
          't-4':
            '<b>El cartucho blanco también debe sacarse de la máquina y agitarse diariamente.</b> Siempre agite bien los nuevos cartuchos de tinta blanca antes de instalarlos en su impresora. Agitar adecuadamente sus nuevos cartuchos de tinta blanca, ayuda a garantizar que sus imprentas salgan brillantes y vibrantes. Consulte el Manual del usuario, página 18, para obtener más información.',
          't-5':
            '<b>Realice una prueba de la boquilla todos los días</b>, para que pueda detectar y resolver rápidamente los posibles problemas con la impresora. Si no se chequea la boquilla a diario, la garantía será anulada. Imprimir a diario no equivale a una prueba de la boquilla.',
          't-6':
            '<b>Especificaciones ambientales: requisito de humedad</b> entre 45 % y 80 % en la pantalla, sin usar medidores externos, <b>requisito de temperatura</b> de 61 °F a 90 °F sin usar medidores externos. Para que la impresora funcione sin problemas, es fundamental que se cumpla el requisito de humedad relativa (HR) en todo momento cuando la impresora está cargada de tinta. Si el entorno está por debajo de la humedad relativa especificada, la tinta se secará más rápidamente en el cabezal de impresión y los inyectores se obstruirán. Si la humedad relativa cae por debajo del 45 % en cualquier momento, será necesario utilizar un humidificador no nebulizador de alta potencia para aumentar la humedad en el área inmediata a la impresora. También tenga en cuenta que será mucho más fácil controlar el entorno en un área pequeña que en una grande.',
          't-7':
            '<b>Asegúrese de que la tinta o los cartuchos de limpieza estén al 5% o más cuando termine de imprimir durante el día o planee dejar la impresora inactiva durante unas horas.</b> Si bien puede seguir imprimiendo utilizando cartuchos con menos del 5% restante, las secuencias de mantenimiento automatizadas vitales de la máquina requieren al menos un 5% o más para completarse. Si no tiene tinta de repuesto disponible, puede llenar su impresora con líquido de limpieza. Consulte la Sección 8.3 de su Manual de usuario. ',
          't-8':
            '<b>Limpie la tira del codificador semanalmente o cada 30 impresiones para ayudar a evitar impresiones borrosas, impresiones dobles y códigos de error.</b> Consulte la sección 8.2 de su manual de usuario o vea el vídeo de mantenimiento semanal de Ricoh DTG University: Ri 1000/2000. ',
          't-9':
            '<b>Asegúrese de que el sensor de obstáculos esté encendido.</b> Si el sensor está apagado, pueden producirse golpes y dañar la estructura. Para verificar si su sensor de obstáculos está habilitado, navegue hasta el panel de OPCIONES. El sensor está encendido cuando la luz azul en el botón SENSOR DE OBSTÁCULOS esta encendida.',
          't-10':
            '<b>Configure la altura de la placa correctamente - justo debajo del sensor de obstrucción.</b> Si la placa está demasiado baja, el espacio adicional puede causar empañamiento y dañar la impresora. Si la prenda se coloca en la placa, el número en el ajustador de altura de la placa debe estar entre 0-2. Si no está usando la prenda, el valor numérico no debe ser superior a 4. Consulte la Sección 2.2 de su Manual del usuario. La altura incorrecta de la placa puede causar que la tinta se empañe dentro de la impresora y se anulará la garantía si se determina que es causada por una altura incorrecta de la placa.',
          't-11':
            '<b>Tenga cuidado al ajustar la altura de la placa o al cambiar las placas.</b> Aunque la impresora es de construcción robusta, la Ri 1000/2000 es una herramienta de precisión y se debe tener cuidado al realizar ajustes en la máquina. NO apriete demasiado la perilla de ajuste de altura de la mesa más allá de “0” e instale con cuidado la placa sin golpearla contra la mesa de impresión.',
          't-12':
            '<b>Asegúrese de completar el mantenimiento DIARIO, SEMANAL y mensual. Si se determina que el mantenimiento no se hace adecuadamente, la garantía se anulará.</b>',
          't-13':
            '<b>Cuando aparece la advertencia, los filtros del ventilador deben reemplazarse. Si se determina que los filtros no se cambian adecuadamente, la garantía se anulará.</b>',
          't-14':
            '<b>¡Mantente actualizado!</b> Visita la página de Descargas para acceder a actualizaciones importantes de su impresora, manual de usuario y AnaRIP.',
        },
      },
    },
    resources: {
      heading: 'Post Training Recursos',
      downloads: 'Descargas',
      download: 'Descargar',
      videos: 'Videos de Entrenamiento',
    },
  },
  schedule: {
    header: 'Agendar Entrenamiento',
    heading: 'Agendar or cancelar entrenamiento en vivo',
    subheading: 'Aqui tu puedes ver, agendar, cancelar o reprogramar tus entrenamientos.',
    list: {
      table: {
        ths: {
          th1: 'Nota Importante*',
          th2: 'Fecha',
          th3: 'Hora',
          th4: 'Maquina',
          th5: 'Tema',
          th6: 'Tipo',
          th7: 'Enlace',
          th8: 'Editar',
        },
        btn: 'Cancelar Entrenamiento',
      },
      btn: 'Agendar nuevo Entrenamiento',
      noTrainings: 'No tienes entrenamientos programados.',
    },
    modalNew: {
      heading: 'Agendar nuevo entrenamiento',
      form: {
        fields: {
          f1: {
            label: 'Seleccione su maquina*',
            placeholder: 'Por favor seleccione una maquina',
          },
          f2: {
            label: 'Numero de celular*',
            placeholder: 'e.g. +1 222 333 4444  or  222 333 4444',
          },
          f3: {
            label: 'Seleccione el tipo de entrenamiento*',
            placeholder: 'Seleccione un tipo de entrenamiento',
          },
          f4: {
            label: 'Seleccione un idioma*',
            placeholder: 'Seleccione el idioma',
          },
          f5: {
            label: 'Seleccione fecha y hora*',
            placeholder: 'Seleccione una fecha & hora ( TIEMPO ORIENTAL )',
          },
        },
        btn: 'Siguiente',
      },
    },
    modalCancel: {
      heading: 'Cancelar el Entrenamiento',
      box: {
        lines: {
          l1: 'Tu entrenamiento online para {machine} en la fecha',
          l2: 'sera cancelado.',
        },
      },
      btn: 'Cancelar mi entrenamiento',
    },
    modalConfirm: {
      heading: 'Agendar Nuevo Entrenamiento',
      box: {
        lines: {
          l1: 'Tu entrenamiento online fue programado para',
        },
      },
      additionalText:
        'Click abajo para agendar tu entrenamiento. Le enviaremos un email con mas instrucciones. Esperamos verte.',
      btn: 'Agendar mi entrenamiento!',
    },
    modalConfirmCancelShedule: {
      box: {
        lines: {
          l1: 'Tu entrenamiento online fue programado para',
        },
      },
      additionalText: 'Estas seguro que no quieres confirmar el entrenamiento ?',
      btn: 'No confirmar mi entrenamiento!',
    },
    videoRecords: {
      heading: 'Clases anteriores',
      noData: 'Nada para mostrar.',
      list: {
        table: {
          ths: {
            th1: 'Fecha',
            th2: 'Hora',
            th3: 'Maquina',
            th4: 'Tema',
            th5: 'Link',
          },
          btn: 'Ver',
        },
      },
    },
  },
  orders: {
    header: {
      heading: 'Ordenes Actuales',
    },
  },
  order: {
    heading: 'Orden# {number}',
    date: 'Ordenado en {date}',
  },
  orderFulfillment: {
    header: {
      heading: 'Cumplimiento # {number}',
      tracking: 'Rastreo # {number}',
    },
    tabOrders: {
      ordered: 'Ordenado',
      picked: 'Elegido',
      packed: 'Empacado',
      shipped: 'Enviado',
    },
    estimatesTimeDelivery: {
      single: {
        constant: 'Este articulo',
        shipped: 'fue despachado en',
        noShipped: 'se espera ser enviado en',
      },
      multiple: {
        constant: 'Estos articulos',
        shipped: 'fueron enviados en',
        noShipped: 'se esparan ser enviados en',
      },
    },
    dropdown: {
      btn: 'Ocultar articulos',
      table: {
        ths: {
          th1: 'articulo',
          th2: 'descripcion',
          th3: 'cantidad',
        },
      },
    },
  },
  referrals: {
    header: {
      heading: 'Recompensas por recomendación',
    },
    intro: {
      heading: {
        general: 'Recomienda a un amigo y gana créditos',
        influencer: 'Recomienda a un amigo y gana recompensas',
      },
      howItWorks: {
        heading: 'Como funciona',
        actionText: 'click aqui para ver',
        list: {
          'l1-general':
            'A continuación se muestran tres enlaces de referencia únicos para promocionar nuestras máquinas e impresoras de bordar. También hay un enlace para promocionar los productos vendidos en nuestra tienda en línea en shop.ricoma.com.',
          'l1-influencer':
            'A continuación se muestran tres enlaces de referencia únicos para promocionar nuestras máquinas e impresoras de bordar. También hay un enlace para promocionar los productos vendidos en nuestra tienda en línea en shop.ricoma.com.',
          'l2-general':
            'Cada enlace de máquina contiene una promoción especial que el representante de ventas puede aplicar si la utiliza para contactarnos.',
          'l2-influencer':
            'Cada enlace de máquina contiene una promoción especial que el representante de ventas puede aplicar si la utiliza para contactarnos.',
          'l3-general':
            'Tras una compra realizada a través de cualquiera de los enlaces proporcionados, obtendrá un crédito en su cuenta, que podrá utilizar para futuras compras en Ricoma.',
          'l3-influencer':
            'Tras una compra realizada a través de cualquiera de los enlaces que proporcionó, recibirá recompensas en su cuenta.',
        },
      },
    },
    social_customer_portal: {
      heading: 'Tu enlace para referir maquinas de bordado:',
      btn: 'copiar enlace',
    },
    social_shop_ricoma: {
      heading: 'Tu enlace para referir en shop.ricoma.com:',
      btn: 'copiar enlace',
      modal_btn: 'Revisa los productos elegibles para recompensas',
      modal_text: 'shop.ricoma.com - Products Eligible for Rewards',
    },
    social_dtp_portal: {
      heading: 'Tu enlace para referir Luminaris 200:',
      btn: 'copiar enlace',
    },
    social_dtf_portal: {
      heading: 'Tu enlace para referir DTF:',
      btn: 'copiar enlace',
    },
    social_chroma_portal: {
      heading: 'Tu enlace para referir Chroma:',
      btn: 'copiar enlace',
    },
    social_dtg_portal: {
      heading: 'Tu enlace para referir DTG:',
      btn: 'copiar enlace',
    },
    stats: {
      blocks: {
        b1: {
          'title-general': 'Creditos Ricoma Disponibles',
          'title-influencer': 'Recompensa Ricoma Disponibles',
          subtitle:
            'Los fondos estan temporalmente desabilitados hasta que el balance pendiente sea mayor que $0.00.',
          'content-general-1': '',
          'content-general-2': '',
          'content-influencer-1': '',
          'content-influencer-2': '',
          tooltip: '',
        },
        b2: {
          'title-general': 'Creditos Ricoma Pendientes',
          'title-influencer': 'Recompensa Ricoma Pendientes',
          subtitle: '',
          'content-general-1': '',
          'content-general-2': '',
          'content-influencer-1': '',
          'content-influencer-2': '',
          tooltip:
            'Este es tu actual balance de recompensas. Este balance refleja el monto total que usted a ganado en base al porcentaje. Este monto puede aparecer negativo si un cliente decide retornar su orden o parte de su orden. No tendra que pagar el balance negativo. Simplemente refiera a otro persona para continuar recibiendo recompensas.',
        },
        b3: {
          'title-general': '',
          'title-influencer': '',
          subtitle: '',
          'content-general-1': 'Ordenes referidas a la fecha:',
          'content-general-2': 'Creditos Ricoma por referidos ganados a la fecha:',
          'content-influencer-1': 'Ordenes referidas a la fecha:',
          'content-influencer-2': 'Recompensa Ricoma por referidos ganados a la fecha:',
          tooltip: '',
        },
      },
      table: {
        heading: 'Historial de Referido',
        ths: {
          th1: 'Factura/Memo #',
          th2: 'Order #',
          th3: 'Fecha de Compra',
          th4: 'Minimo a Referir',
          th5: 'Total',
          th6: 'Porcentaje Ganado',
          th7: 'Monto de Recompensa',
          th8: 'Balance',
        },
        csvBtn: 'Exportar .csv',
      },
      csv: {
        labels: {
          l1: 'FACTURA/MEMO #',
          l2: 'FECHA DE COMPRA',
          l3: 'RECOMPENSA SHOPIFY',
          l4: 'MINIMO A REFERIR',
          l5: 'TOTAL',
          l6: 'PORCENTAJE GANADO',
          l7: 'MONTO DE RECOMPENSA',
          l8: 'TIPO',
          l9: 'BALANCE',
        },
      },
    },
  },
  transactions: {
    header: {
      heading: 'Historial de Transacciones',
    },
    table: {
      heading: '',
      toolbar: {
        preview: {
          credit: 'Credito',
          balance: 'Balance',
        },
      },
      ths: {
        th1: 'tipo de transacciones',
        th2: 'detalles',
        th3: 'fecha creada',
        th4: 'factura/memo #',
        th5: 'order de venta',
        th6: 'valor',
        th7: 'valor restante',
        th8: 'estado',
      },
      csvBtn: 'Exportar .csv',
    },
    csv: {
      labels: {
        l1: 'TIPO DE TRANSACCIONES',
        l2: 'FECHA CREADA',
        l3: 'FACTURA/MEMO #',
        l4: 'ORDER DE VENTA',
        l5: 'VALOR',
        l6: 'VALOR RESTANTE',
        l7: 'ESTADO',
      },
    },
    details: {
      header: {
        heading: 'Detalles de la transaccion',
      },
      preview: {
        transactionType: 'Tipo de Transaccion',
        transactionAmount: 'Valor de la Transaccion',
        transactionDate: 'Fecha de la Transaccion',
        invoiceMemo: 'Factura/Memo #',
        salesOrder: 'Orden de Venta',
      },
      table: {
        ths: {
          th1: 'articulos',
          th2: 'descripcion',
          th3: 'precio',
        },
      },
    },
  },
  account: {
    firstTimeModal: {
      heading: 'Elija su idioma preferido',
      description:
        'Puede cambiar su selección de idioma en cualquier momento según sus preferencias.',
    },
    header: {
      heading: 'Configuracion de Cuenta',
    },
    settings: {
      fields: {
        name: 'Nombre',
        email: 'Correo',
        password: 'Contraseña',
        language: 'Idioma',
      },
      btns: {
        edit: 'edita',
        password: 'cambia contraseña',
        save: 'guarde',
      },
    },
  },
  tooltipDateRange: {
    prefix: 'Rango:',
    range: {
      all: 'Todos los Datos',
      today: 'Hoy',
      yesterday: 'Ayer',
      thisWeek: 'Esta semana',
      lastWeek: 'Semana pasada',
      lastMonth: 'Mes pasada',
      thisQuarter: 'Este trimestre',
      lastQuarter: 'Trimestre pasada',
      thisYear: 'Este año',
      lastYear: 'Año pasado',
      custom: 'Rango de fechas',
    },
  },
  pagination: {
    prev: 'Anterior',
    next: 'Siguiente',
  },
};
